(function () {
  'use strict';

  angular.module('uteAddToCalendar').directive('uteAddToCalendar', UteAddToCalendar);

  UteAddToCalendar.$inject = ['$timeout'];

  function UteAddToCalendar($timeout) {
    return {
      restrict: 'E',
      scope: {
        startDate: '@',
        endDate: '@',
        title: '@',
        dropdownTitle: '@',
        description: '@',
        location: '@',
        className: '@',
        btnText: '@',
        caret: '@',
        hoverText: '@',
        format: '@'
      },
      templateUrl: 'modules/uteAddToCalendar/uteAddToCalendar.view.html',
      controller: 'uteAddToCalendarController',
      bindToController: true,
      link: function (scope, element) {
        var addToCalendarOptions = element.find('ul.dropdown-menu').addClass('addtocalendar-options');
        element.find('addtocalendar span').hide();

        $timeout(function() {
          element.find('span.caret').removeClass('caret').addClass('chevron');
          element.find('addtocalendar span').show();
        });

        scope.$on('$destroy', function () {
          addToCalendarOptions = null;
        });
      }
    };
  }

})();
